import React from 'react';
import LegalPage from '../components/LegalPage';

const sections = [
    {
        title: 'Întâi, cu noi',
        text: 'Scrieți-ne la contact@evoomedical.ro sau depuneți o reclamație la recepție. Răspundem în scris în cel mult 30 de zile.'
    },
    {
        title: 'ANPC',
        text: 'Autoritatea Națională pentru Protecția Consumatorilor — www.anpc.ro, cu Comisariatul Județean pentru Protecția Consumatorilor Alba.'
    },
    {
        title: 'Soluționarea alternativă a litigiilor (SAL)',
        text: 'Puteți apela la procedura SAL a ANPC: https://anpc.ro/ce-este-sal/. Pictograma SAL de pe site trimite la această pagină.'
    },
    {
        title: 'Temeiul',
        unnumbered: true,
        text: 'Ordonanța Guvernului nr. 21/1992 privind protecția consumatorilor; Ordonanța Guvernului nr. 38/2015 privind soluționarea alternativă a litigiilor; Ordinul președintelui ANPC nr. 449/2022. Platforma europeană SOL (ODR) a fost închisă la 20 iulie 2025, prin Regulamentul (UE) 2024/3228, de aceea nu mai apare pe site.'
    }
];

function ProtectiaConsumatorilor() {
    return (
        <LegalPage
            eyebrow="Informații legale"
            title="Protecția consumatorilor"
            intro="Dacă nu ajungem împreună la o soluție, aveți la dispoziție căi gratuite sau ieftine de rezolvare a disputei."
            sections={sections}
            footnote="EVOO-COM-MAN-01-R3 · versiunea din 25.10.2026"
        />
    );
}

export default ProtectiaConsumatorilor;
